var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
var CONSENT_KEY = "cookie_consent";
var getStoredConsent = function () {
    return localStorage.getItem(CONSENT_KEY);
};
var updateGtagConsent = function (value) {
    if (window.gtag) {
        window.gtag("consent", "update", {
            analytics_storage: value,
        });
    }
};
var CookieConsent = function () {
    var _a = __read(useState(false), 2), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        var stored = getStoredConsent();
        if (stored === null) {
            setVisible(true);
        }
        else if (stored === "granted") {
            updateGtagConsent("granted");
        }
    }, []);
    var handleAccept = function () {
        localStorage.setItem(CONSENT_KEY, "granted");
        updateGtagConsent("granted");
        setVisible(false);
    };
    var handleDecline = function () {
        localStorage.setItem(CONSENT_KEY, "denied");
        updateGtagConsent("denied");
        setVisible(false);
    };
    if (!visible) {
        return null;
    }
    return (_jsxs(Paper, { elevation: 6, role: "dialog", "aria-label": "Cookie consent", sx: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1400,
            p: { xs: 2, sm: 3 },
            borderRadius: 0,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
        }, children: [_jsx(Typography, { variant: "body2", sx: { flex: 1 }, children: "We use cookies to understand how you use our site and improve your experience. You can accept or decline analytics cookies." }), _jsxs(Box, { sx: {
                    display: "flex",
                    gap: 1,
                    flexShrink: 0,
                }, children: [_jsx(Button, { variant: "outlined", size: "small", onClick: handleDecline, children: "Decline" }), _jsx(Button, { variant: "contained", size: "small", onClick: handleAccept, children: "Accept" })] })] }));
};
export default CookieConsent;
